import RfmBandFields from './rfm-band-fields';

type CardFrequencyFormProps = {
  enableForm: boolean;
};

export function CardFrequencyForm({ enableForm }: CardFrequencyFormProps) {
  return <RfmBandFields dimension="frequency" enableForm={enableForm} />;
}
